// AUTO-GENERATED by scripts/gen-version.js — do not edit by hand.
// Regenerated on every "npm start" / "npm run build".
export const APP_VERSION = "1.0.43";
export const BUILD_TIME = "2026-11-05T06:07:45.320Z";
export const BUILD_ID = "1.0.43+2026-11-05T06:07:45.320Z";
